import { NewBooking, WorkDetails as NewWorkDetails } from "types/NewBooking";
import { AdditionalServiceType, BookingDetails, BookingSummaryInformation, WorkDetails, WorkType } from "generated/types/types";
import type { TFunction } from "i18next";

export const getAdditionalService = (bookingDetails: BookingDetails): AdditionalServiceType => {
    return bookingDetails.whileUWait
        ? AdditionalServiceType.WhileUWait
        : bookingDetails.collection
            ? AdditionalServiceType.Delivery
            : bookingDetails.courtesyCar
                ? AdditionalServiceType.Courtesy
                : AdditionalServiceType.NoAdditional;
};

export const convertExistingBookingToInputData = (existingBooking: BookingSummaryInformation, t: TFunction): NewBooking => {
    return {
        previousBookingId: Number(existingBooking.bookingDetails.bookingId),
        vehicleDetails: {
            encryptedId: "",
            scheme: { encryptedId: "", name: "" },
            model: "",
            make: "",
            derivative: "",
            odoReading: existingBooking.vehicleDetails.odoReading,
            registrationNumber: existingBooking.vehicleDetails.registrationNumber,
            motDueDate: existingBooking.vehicleDetails.motDueDate,
            safetyRecall: existingBooking.vehicleDetails.safetyRecall,
            assetId: ""
        },

        workDetails: extractWorkDetailsFromExistingBooking(existingBooking, t),
        driverDetails: {
            driverName: existingBooking.bookingDetails.contactName,
            email: existingBooking.bookingDetails.contactEmail,
            phoneNumber: existingBooking.driverDetails.phoneNumber,
            smsMobileNo: null,
            contactPreferences: existingBooking.driverDetails.contactPreferences,
            bookerName: existingBooking.driverDetails.bookerName,

        },
        selectedServiceCentreDetails: null,
    };
};

export const extractWorkDetailsFromExistingBooking = (existingBooking: BookingSummaryInformation, t: TFunction): NewWorkDetails => {
    const existingWorkDetails: WorkDetails = existingBooking.workDetails;
    const repairOtherText = existingWorkDetails.userInvestigationLines.join("\n");

    const workRequired: WorkType[] = [];

    if (existingWorkDetails.motRequired) {
        workRequired.push(WorkType.Mot);
    }

    if (existingWorkDetails.tyreWorkDescription) {
        workRequired.push(WorkType.Tyres);
    }

    if (repairOtherText) {
        workRequired.push(WorkType.RepairOther);
    }

    const NoServiceRequiredText = t("booking_conversion_no_service_required");
    if (existingBooking.workDetails.workDescriptions.length > 0 && !existingBooking.workDetails.workDescriptions[0].includes(NoServiceRequiredText)) {
        workRequired.push(WorkType.Service);
    }

    const newWorkDetails: NewWorkDetails = {
        workRequired: workRequired,
        repairOtherText: repairOtherText,
        additionalServiceRequested: getAdditionalService(existingBooking.bookingDetails),
        collectionContactName: existingBooking.bookingDetails.collectionContactName,
        collectionContactNumber: existingBooking.bookingDetails.collectionContactNumber,
        collectionAddress: existingBooking.bookingDetails.collectionAddressLines?.join("\n") ?? null,
        collectionInstruction: existingBooking.bookingDetails.collectionInstruction,
        additionalNotes: existingBooking.workDetails.additionalNotes,
        safetyRecall: existingBooking.vehicleDetails.safetyRecall ?? false,
        safetyRecallText: t("booking_conversion_no_service_required_desc")
    };
    return newWorkDetails;
};
